// extracted by css-extract-rspack-plugin
export default {"root":"root-nybNrn","row":"row-kKzUjF","loader":"loader-SUYytj","label":"label-I8zQn6"};